// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { getCallsWithParams } from "../../services/callReportService";
// import "./CallReport.css";

// const ITEMS_PER_PAGE = 10;

// const CallReport = () => {
//   const [data, setData] = useState([]);
//   const [summary, setSummary] = useState({});
//   const [page, setPage] = useState(1);

//   // Local quick search state
//   const [searchTerm, setSearchTerm] = useState("");

//   // Date Filters
//   const [filters, setFilters] = useState({
//     from: "",
//     to: "",
//     callType: "",
//   });

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   // API Fetch for Date/Type filters
//   const fetchData = useCallback(async () => {
//     try {
//       const params = {};
//       if (filters.from && filters.to) {
//         params.from = filters.from;
//         params.to = filters.to;
//       }
//       if (filters.callType) params.call_type = filters.callType;

//       const res = await getCallsWithParams(params);
//       setData(res?.data || []);
//       setSummary(res?.summary || {});
//       setPage(1);
//     } catch (error) {
//       console.error("Error fetching call data:", error);
//     }
//   }, [filters]);

//   // Initial load
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const resetFilters = () => {
//     setFilters({ from: "", to: "", callType: "" });
//     setSearchTerm("");
//     setPage(1);
//   };

//   // 🔥 Local Search Logic: Filters the loaded data by Name, Mobile, or Lead
//   const filteredData = useMemo(() => {
//     const lowerSearch = searchTerm.toLowerCase().trim();
//     if (!lowerSearch) return data;

//     return data.filter((item) => {
//       const uName = item.user?.name?.toLowerCase() || "";
//       const lName = item.lead?.name?.toLowerCase() || "";
//       const phone = item.phone || "";

//       return uName.includes(lowerSearch) ||
//              lName.includes(lowerSearch) ||
//              phone.includes(lowerSearch);
//     });
//   }, [data, searchTerm]);

//   // Pagination Logic
//   const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   const getRoleLabel = (role) => {
//     const roles = { tm: "Team Manager", sales: "Sales Executive" };
//     return roles[role] || role || "-";
//   };

//   const formatDuration = (sec) => {
//     if (!sec) return "00:00:00";
//     const h = Math.floor(sec / 3600).toString().padStart(2, "0");
//     const m = Math.floor((sec % 3600) / 60).toString().padStart(2, "0");
//     const s = (sec % 60).toString().padStart(2, "0");
//     return `${h}:${m}:${s}`;
//   };

//   return (
//     <div className="call-container">
//       <h5>Calls Report Dashboard</h5>

//       {/* API FILTERS (Dates & Type) */}
//       <div className="filters">
//         <input type="date" name="from" value={filters.from} onChange={handleFilterChange} />
//         <input type="date" name="to" value={filters.to} onChange={handleFilterChange} />

//         <select name="callType" value={filters.callType} onChange={handleFilterChange}>
//           <option value="">All Calls</option>
//           <option value="incoming">Incoming</option>
//           <option value="outgoing">Outgoing</option>
//         </select>

//         <button onClick={fetchData}>Apply</button>

//         {/* SINGLE LOCAL SEARCH BAR */}
//         <input
//           type="text"
//           placeholder="Search Name, Mobile, or Lead..."
//           value={searchTerm}
//           onChange={(e) => {
//             setSearchTerm(e.target.value);
//             setPage(1);
//           }}
//           className="global-search"
//         />

//         <button onClick={resetFilters} className="reset">Reset All</button>
//       </div>

//       {/* SUMMARY CARDS - Fixed values from API */}
//       <div className="summary">
//         <div className="card">
//           <strong>Total Calls:</strong> {summary.total_calls || 0}
//         </div>
//         <div className="card">
//           <strong>Duration:</strong> {summary.total_duration_formatted || "00:00:00"}
//         </div>
//         <div className="card">
//           <strong>Outgoing:</strong> {summary.call_type_breakdown?.outgoing || 0}
//         </div>
//         <div className="card">
//           <strong>Incoming:</strong> {summary.call_type_breakdown?.incoming || 0}
//         </div>
//       </div>

//       <div className="table-wrapper">
//         <table className="report-table">
//           <thead>
//             <tr>
//               <th>User</th>
//               <th>Role</th>
//               <th>Lead</th>
//               <th>Phone</th>
//               <th>Type</th>
//               <th>Duration</th>
//               <th>Status</th>
//               <th>Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((call) => (
//                 <tr key={call.id}>
//                   <td><strong>{call.user?.name || "-"}</strong></td>
//                   <td>{getRoleLabel(call.user?.role)}</td>
//                   <td>{call.lead?.name || "-"}</td>
//                   <td>{call.phone}</td>
//                   <td className={`type-${call.call_type}`}>{call.call_type}</td>
//                   <td>{formatDuration(call.duration)}</td>
//                   <td>{call.call_status || "-"}</td>
// <td>
//   {new Date(call.created_at).toLocaleString('en-GB', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: false
//   })}
// </td>                </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">No results found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {totalPages > 1 && (
//         <div className="pagination">
//           <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</button>
//           <span>Page {page} of {totalPages}</span>
//           <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CallReport;

import React, { useEffect, useState, useCallback, useMemo } from "react";
import { 
  FiUser, FiPhoneCall, FiClock, FiCalendar, FiSearch, FiFilter,
  FiRefreshCw, FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight,
  FiTrendingUp, FiUserCheck, FiUserX, FiStar, FiAward, FiMessageCircle,
  FiBriefcase, FiTag, FiMail, FiPhone
} from "react-icons/fi";
import { getCallsWithParams } from "../../services/callReportService";
import { getCategories } from "../../services/categoryService";
import { getLeadStatuses } from "../../services/leadService";
import "./CallReport.css";

const CallReport = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [summary, setSummary] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    from: "",
    to: "",
    callType: "",
    role: "",
    status: "",
    category: "",
    source: "",
  });

  const [statuses, setStatuses] = useState([]);

  // Load categories and statuses from API
  useEffect(() => {
    const loadData = async () => {
      try {
        const catRes = await getCategories();
        if (catRes.status === "success") setCategories(catRes.data || []);
        
        const statRes = await getLeadStatuses();
        if (statRes.status === "success") setStatuses(statRes.data || []);
      } catch (error) {
        console.error("Data load error:", error);
      }
    };
    loadData();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      if (filters.callType) params.call_type = filters.callType;
      if (filters.role) params.role = filters.role;
      if (filters.status) params.lead_status = filters.status;
      if (filters.category) params.category = filters.category;
      if (filters.source) params.source = filters.source;
      if (searchTerm) params.search = searchTerm;

      const res = await getCallsWithParams(params);
      setData(res?.data || []);
      setSummary(res?.summary || {});
      setCurrentPage(1);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  }, [filters, searchTerm]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const resetFilters = () => {
    setFilters({ from: "", to: "", callType: "", role: "", status: "", category: "", source: "" });
    setSearchTerm("");
    setCurrentPage(1);
  };

  const getRoleLabel = (role) => {
    if (role === "tm") return "Team Manager";
    if (role === "sales") return "Sales Executive";
    return "Unknown";
  };

  const formatStatusLabel = (status) => {
    if (!status) return "";
    return status
      .toString()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .replace(/\bSram\b/i, "SRAM")
      .replace(/\bDnd\b/i, "DND");
  };



  const getRoleIcon = (role) => {
    if (role === "tm") return <FiUserCheck />;
    if (role === "sales") return <FiBriefcase />;
    return <FiUser />;
  };

  const formatDuration = (sec) => {
    if (!sec && sec !== 0) return "00:00:00";
    const h = String(Math.floor(sec / 3600)).padStart(2, "0");
    const m = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  // Client‑side filtering (search + date range on calls & leads + role + status + category)
  const filteredData = useMemo(() => {
    let result = [...data];
    const term = searchTerm.toLowerCase().trim();

    // Search by agent name/email/mobile
    if (term) {
      result = result.filter(agent =>
        agent.name?.toLowerCase().includes(term) ||
        agent.email?.toLowerCase().includes(term) ||
        agent.mobile?.includes(term)
      );
    }

    // Role filter
    if (filters.role) {
      result = result.filter(agent => agent.role === filters.role);
    }

    // Date range filter (check both leads AND calls)
    if (filters.from || filters.to) {
      const fromDate = filters.from ? new Date(filters.from) : null;
      const toDate = filters.to ? new Date(filters.to) : null;
      result = result.filter(agent => {
        // Check if any lead falls within range
        const hasLeadInRange = agent.leads?.some(lead => {
          const created = new Date(lead.created_at.split(" ")[0]);
          if (fromDate && created < fromDate) return false;
          if (toDate && created > toDate) return false;
          return true;
        });

        // Check if any call falls within range
        const hasCallInRange = agent.calls?.some(call => {
          const callDate = new Date(call.start_time?.split(" ")[0]);
          if (fromDate && callDate < fromDate) return false;
          if (toDate && callDate > toDate) return false;
          return true;
        });

        // Keep agent if they have leads OR calls in range
        return hasLeadInRange || hasCallInRange;
      });
    }

    // Lead status filter
    if (filters.status) {
      result = result.filter(agent =>
        agent.leads?.some(lead => lead.status === filters.status)
      );
    }

    // Lead category filter
    if (filters.category) {
      result = result.filter(agent =>
        agent.leads?.some(lead => lead.category_name === filters.category)
      );
    }

    // Source filter
    if (filters.source) {
      result = result.filter(agent =>
        agent.leads?.some(lead => lead.source?.toLowerCase() === filters.source.toLowerCase())
      );
    }

    return result;
  }, [data, searchTerm, filters]);

  // Flatten calls for pagination (one row per call)
  const allCalls = useMemo(() => {
    const flatCalls = [];
    filteredData.forEach(user => {
      if (user.calls && user.calls.length > 0) {
        user.calls.forEach(call => {
          flatCalls.push({
            ...call,
            user_id: user.id,
            user_name: user.name,
            user_role: user.role,
            user_email: user.email,
            user_mobile: user.mobile,
            lead_name:
              call.lead_name ||
              call.name ||
              user.leads?.[0]?.name ||
              "-",
          });
        });
      }
    });
    return flatCalls;
  }, [filteredData]);

  // Pagination at call level
  const totalPages = Math.ceil(allCalls.length / itemsPerPage);
  const paginatedCalls = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return allCalls.slice(start, start + itemsPerPage);
  }, [allCalls, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters).filter(v => v && v !== "").length + (searchTerm ? 1 : 0);
  };

  const roleData = summary.role_breakdown || {};
  const callType = summary.call_type_breakdown || {};

  // Helper to get first lead's category (for display in single row per agent)
  const getAgentCategory = (agent) => {
    if (!agent.leads || agent.leads.length === 0) return "-";
    return agent.leads[0].category_name || "-";
  };

  return (
    <div className="call-container">
      <div className="call-header">
        <div className="header-title">
          <h3>Call Activity Report</h3>
          <p>Agent performance and call summaries</p>
        </div>
        <div className="header-actions">
          <button className="refresh-btn" onClick={fetchData} disabled={loading}>
            <FiRefreshCw className={loading ? "spinning" : ""} /> Refresh
          </button>
        </div>
      </div>

      <div className="search-section">
        <div className="search-wrapper">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by agent name, email or mobile..."
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            className="search-input"
          />
          {searchTerm && (
            <button className="clear-search" onClick={() => setSearchTerm("")}>×</button>
          )}
        </div>
        <button 
          className={`filter-toggle ${showFilters ? "active" : ""}`}
          onClick={() => setShowFilters(!showFilters)}
        >
          <FiFilter /> Filters
          {getActiveFiltersCount() > 0 && (
            <span className="filter-badge">{getActiveFiltersCount()}</span>
          )}
        </button>
      </div>

      {showFilters && (
        <div className="filters">
          <input type="date" name="from" value={filters.from} onChange={handleFilterChange} placeholder="Lead From Date" />
          <input type="date" name="to" value={filters.to} onChange={handleFilterChange} placeholder="Lead To Date" />
      <select name="callType" value={filters.callType} onChange={handleFilterChange}>
  <option value="">All Call Types</option>
  <option value="incoming">Incoming</option>
  <option value="outgoing">Outgoing</option>
  <option value="answered">Answered</option>
  <option value="not_answered">Not Answered</option>
  <option value="busy">Busy</option>
  <option value="switched_off">Switched Off</option>
  <option value="wrong_number">Wrong Number</option>
  <option value="invalid_number">Invalid Number</option>
  <option value="not_reachable">Not Reachable</option>
</select>
          <select name="role" value={filters.role} onChange={handleFilterChange}>
            <option value="">All Roles</option>
            <option value="sales">Sales Executive</option>
            <option value="tm">Team Manager</option>
          </select>
       <select name="status" value={filters.status} onChange={handleFilterChange}>
  <option value="">Lead Status</option>
  {[...statuses].sort((a, b) => (a.name || "").localeCompare(b.name || "")).map((s) => (
    <option
      key={s.id}
      value={s.name.toLowerCase().replace(/\s+/g, "_")}
    >
      {formatStatusLabel(s.name)}
    </option>
  ))}
</select>
          <select name="category" value={filters.category} onChange={handleFilterChange}>
            <option value="">Lead Category</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.name}>{cat.name}</option>
            ))}
          </select>
          <select name="source" value={filters.source} onChange={handleFilterChange}>
            <option value="">All Sources</option>
            <option value="Website">Website</option>
            <option value="Facebook">Facebook</option>
            <option value="Google Ads">Google Ads</option>
            <option value="Reference">Reference</option>
          </select>
          <button onClick={fetchData} className="apply-btn">Apply Filters</button>
          <button onClick={resetFilters} className="reset-btn">Reset All</button>
        </div>
      )}

      <div className="summary">
        <div className="card"><div className="card-content"><span className="card-label">Total Agents</span><span className="card-value">{summary.total_users ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Total Calls</span><span className="card-value">{summary.total_calls ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Outgoing</span><span className="card-value">{summary.outgoing_calls ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Incoming</span><span className="card-value">{summary.incoming_calls ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Total Leads</span><span className="card-value">{summary.total_leads ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Follow-ups</span><span className="card-value">{summary.total_followups ?? 0}</span></div></div>
        <div className="card"><div className="card-content"><span className="card-label">Total Duration</span><span className="card-value">{summary.total_call_duration_formatted ?? "00:00:00"}</span></div></div>
      </div>

      <div className="limit-selector">
        <div className="entries-control">
          <label>Show</label>
          <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>entries</span>
        </div>
        <div className="record-count">
          Showing {paginatedCalls.length} of {allCalls.length} total calls
        </div>
      </div>

      <div className="table-responsive">
        <table className="report-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Lead Name</th>
              <th>Phone</th>
              <th>Type</th>
              <th>Status</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="loading-cell"><div className="loader"></div> Loading...</td></tr>
            ) : paginatedCalls && paginatedCalls.length > 0 ? (
              paginatedCalls.map((call, idx) => (
                <tr key={`${call.user_id}-${call.call_id}-${idx}`}>
                  <td className="user-cell">
                    <div className="user-info">
                      <div className="user-avatar">{getRoleIcon(call.user_role)}</div>
                      <div className="user-details">
                        <strong>{call.user_name || "-"}</strong>
                        <small>{getRoleLabel(call.user_role)}</small>
                        <small className="user-email">{call.user_email}</small>
                        <small className="user-mobile">{call.user_mobile}</small>
                      </div>
                    </div>
                  </td>
                  <td>{call.lead_name || "-"}</td>
                  <td>{call.phone || "-"}</td>
                  <td><span className={`call-type call-type-${call.call_type?.toLowerCase()}`}>{call.call_type}</span></td>
                  <td><span className={`call-status call-status-${call.call_status?.toLowerCase().replace(/\s+/g, "-")}`}>{call.call_status || "Pending"}</span></td>
                  <td className="date-cell">
                    {call.start_time ? new Date(call.start_time).toLocaleString('en-GB', { 
                      day: '2-digit', month: '2-digit', year: 'numeric',
                      hour: '2-digit', minute: '2-digit', second: '2-digit',
                      hour12: false 
                    }) : "-"}
                  </td>
                  <td className="date-cell">
                    {call.end_time ? new Date(call.end_time).toLocaleString('en-GB', { 
                      day: '2-digit', month: '2-digit', year: 'numeric',
                      hour: '2-digit', minute: '2-digit', second: '2-digit',
                      hour12: false 
                    }) : "-"}
                  </td>
                  <td className="duration-cell"><strong>{call.duration_formatted || "00:00:00"}</strong></td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="8" className="no-data"><FiPhoneCall className="no-data-icon" /><p>No data found</p><small>Adjust filters or search</small></td></tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => handlePageChange(1)}><FiChevronsLeft /> First</button>
          <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}><FiChevronLeft /> Prev</button>
          <span className="page-info">Page {currentPage} of {totalPages}</span>
          <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next <FiChevronRight /></button>
          <button disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}>Last <FiChevronsRight /></button>
        </div>
      )}
    </div>
  );
};

export default CallReport;